import React from 'react';

const IconCard2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M39.288 12.369L10.9252 7.28315C7.73282 6.71056 4.80005 9.16448 4.80005 12.4076V33.1485C4.80005 36.3379 7.64138 38.7774 10.7941 38.2949L39.2094 33.9453C40.7344 33.7119 41.8606 32.4002 41.8606 30.8575V15.4437C41.8606 13.9311 40.7767 12.6361 39.288 12.369Z" fill="#95FBBC" />
  </svg>
);

export default IconCard2;
